import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATALOGUES } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

const IMG = "https://static.prod-images.emergentagent.com/jobs/f72ff8ae-82c0-4d5d-b45e-99c40156b80b/images/";
const TILE_IMAGES = {
  tshirts_shorts: IMG + "084243db857d22407fab5b1b5f75d7a54aed229bb5ee87fe1796960ac217da76.jpeg",
  baskets: IMG + "e7200d85622950496801e0ef7168c561cbf60f91ae8da6731fcd185313cc9620.jpeg",
  jeans_pulls: IMG + "725e87210359d9808ac33088dfc3971365de198d743646d1c7ae628b9619ac46.jpeg",
  sacs_luxe: IMG + "a179867ed302ab0d2f56dc29b8836f900dfb3d010bb86e434ec35378c98e7cf8.jpeg",
};

export const CatalogueTiles = () => (
  <section data-testid="home-catalogues" className="py-20 lg:py-28 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-blood mb-3">[ 4 Catalogues ]</p>
        <h2 className="font-syne font-extrabold uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-none mb-12">
          Choisis ton<br />terrain<span className="text-blood">.</span>
        </h2>
      </Reveal>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
        {CATALOGUES.map((c, i) => (
          <Reveal key={c.key} delay={i * 0.08}>
            <Link
              to={`/boutique?cat=${c.key}`}
              data-testid={`home-catalogue-${c.key}`}
              className="group relative block aspect-[4/5] overflow-hidden border border-white/10 hover:border-blood transition-colors"
            >
              <img
                src={TILE_IMAGES[c.key]}
                alt={c.label}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover grayscale-[40%] transition-all duration-700 group-hover:grayscale-0 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
              <span className="absolute top-4 left-4 font-mono text-xs text-blood tracking-[0.3em]">0{i + 1}</span>
              <span className="absolute top-3 right-4 text-3xl lg:text-5xl drop-shadow" aria-hidden="true">{c.emoji}</span>
              <div className="absolute bottom-0 left-0 right-0 p-5 lg:p-6 flex items-end justify-between gap-3">
                <h3 className="font-syne font-extrabold uppercase tracking-tight text-lg sm:text-2xl leading-none">{c.label}</h3>
                <span className="shrink-0 bg-white text-ink p-2.5 group-hover:bg-blood group-hover:text-white transition-colors">
                  <ArrowUpRight size={18} />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
